module.exports = __webpack_public_path__ + "15b897fada60a32c453c6a7f0d4f7be3.jpg";